
enum CompanyHotelDashboardFilter {
	PROVIDER='PROVIDER',
	GUESTS='GUESTS',
	NIGHTS='NIGHTS',
	RATE='RATE',
	PLATFORM='PLATFORM',
	FLEX='FLEX',
	ROOM='ROOM',
	MEAL='MEAL',
	REGION='REGION',
	AIRPORT_CODE='AIRPORT_CODE',
	COMPETITOR_TAGS='COMPETITOR_TAGS'
}

export default CompanyHotelDashboardFilter;